export const GoogleProviderId = '1057945459349-dtnnl3chnf99qe1ftqtjlt38ni7gcs5n.apps.googleusercontent.com';
export const CRESTAHOST = 'https://api.cresta.cl/shop-admin';
export const LOGIN_URL = `${CRESTAHOST}/login`;
export const LIST_URL = `${CRESTAHOST}/stores/:storeid/:key`;
export const environment = {
  production: true
};
